(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('BatteryTestDetailController', BatteryTestDetailController);

    BatteryTestDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'BatteryTest', 'Battery', 'Test'];

    function BatteryTestDetailController($scope, $rootScope, $stateParams, entity, BatteryTest, Battery, Test) {
        var vm = this;
        vm.batteryTest = entity;
        vm.load = function (id) {
            BatteryTest.get({id: id}, function(result) {
                vm.batteryTest = result;
            });
        };
        var unsubscribe = $rootScope.$on('ipmApp:batteryTestUpdate', function(event, result) {
            vm.batteryTest = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
